import { Button, Card, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const catalogueInfoStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: '20px',
  },
  header: {
    backgroundColor: '#FAFAFA',
    paddingBottom: 10,
  },
  title: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  hideTitle: {
    padding: 0,
  },
}));
function CustomCard({
  children,
  hideTitle,
  title,
  showAction,
  actionText,
  subAction,
  actionVariant = 'outlined',
}) {
  const classes = catalogueInfoStyles();
  return (
    <Card className={classes.root}>
      <CardHeader
        title={hideTitle ? null : title.toUpperCase()}
        classes={{
          title: hideTitle ? '' : classes.title,
          root: hideTitle ? classes.hideTitle : classes.header,
        }}
        action={
          showAction ? (
            <>
              {subAction ? subAction : null}
              <Button
                variant={actionVariant}
                color="primary"
                onClick={showAction}
                style={{ backgroundColor: '#5850EC' }}
              >
                {actionText}
              </Button>
            </>
          ) : subAction ? (
            subAction
          ) : null
        }
      />
      {children}
    </Card>
  );
}

export { CustomCard };
